import { head } from '../../array-utils';

export const createRegexMatcher = (regexp: RegExp) => (input: string) => head(input.match(regexp) ?? [])?.length ?? 0;
